module.exports = __webpack_public_path__ + "static/media/WBN_1.574be4f2.png";